import { Injectable } from '@angular/core';
import { QuestionnaireTemplate, QuestionnaireType } from '../../../../../backend/server/data-models/questionnaire-template/questionnaire-template.model';
import { AbstractService } from '../../shared/AbstractService';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireTemplateService extends AbstractService<QuestionnaireTemplate> {

  constructor() {
    super("questionnaire-template");
  }

  delete(id: string, seq: number): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return Meteor.call("questionnaire-template.delete", id, seq, (err, res) => {
        console.warn("questionnaire-template.delete - id: " + id + "; seq: " + seq);
        if (!err) {
          console.warn(res);
          resolve(res);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  get(id: string): Promise<QuestionnaireTemplate> {
    return new Promise<QuestionnaireTemplate>((resolve, reject) => {
      Meteor.call("questionnaire-template.get", id, (err, res) => {
        console.warn("questionnaire-template.get");
        if (!err) {
          console.warn(res);
          resolve(new QuestionnaireTemplate(res));
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  create(data: QuestionnaireTemplate): Promise<QuestionnaireTemplate> {
    return new Promise<QuestionnaireTemplate>((resolve, reject) => {
      return Meteor.call("questionnaire-template.create", data, (err, res) => {
        console.warn("questionnaire-template.create");
        if (!err) {
          console.warn(res);
          resolve(new QuestionnaireTemplate(res));
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  update(id: string, seq: number, data: QuestionnaireTemplate): Promise<QuestionnaireTemplate> {
    return new Promise<QuestionnaireTemplate>((resolve, reject) => {
      return Meteor.call("questionnaire-template.update", id, seq, data, (err, res) => {
        console.warn("questionnaire-template.update");
        if (!err) {
          console.warn(res);
          resolve(new QuestionnaireTemplate(res));
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  list(name: string, type: QuestionnaireType, onlyActives: boolean): Promise<QuestionnaireTemplate[]> {
    return new Promise<QuestionnaireTemplate[]>((resolve, reject) => {
      return Meteor.call("questionnaire-template.list", name, type, onlyActives, (err, res: any[]) => {
        console.warn("questionnaire-template.list (name: " + name + "; type: " + type + "; onlyActives: " + onlyActives + ")");
        if (!err) {
          // console.warn(res);
          const result: QuestionnaireTemplate[] = [];
          res.forEach(data => {
            result.push(new QuestionnaireTemplate(data));
          });
          resolve(result);
        } else {
          // console.warn(err);
          reject(err);
        }
      });
    });
  }
}
